import { Component, OnInit } from '@angular/core';
import { Globals } from 'src/app/globals';
import { ApiService } from 'src/app/services/api.service';
import { SessionService } from 'src/app/services/session.service';

@Component({
  selector: 'app-popover',
  templateUrl: './popover.component.html',
  styleUrls: ['./popover.component.scss'],
})
export class PopoverComponent implements OnInit {

  customerNumber: string;
  isBusinessVersion: boolean;

  constructor(
    private api: ApiService,
    private session: SessionService,
    private globals: Globals
    ) { }

  ngOnInit() {
    if (!this.globals.IS_BUSINESS_VERSION) {
      this.api.getCurrentUser().subscribe(
        (res: any) => {
          this.customerNumber = res.customerNumber;
        }
      );
    }
    else {
      this.isBusinessVersion = true;
    }

  }

}
